import { Dispatch, SetStateAction } from "react";
import { FormState } from "./Form";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import styles from "./Form.module.scss";
import { SimpleButton } from "@/components/Button/Button";
import { FadeIn } from "@/components/Animation";
import { CustomSVG } from "@/components/_primitives/CustomSVG/CustomSVG";

interface FormMessagesProps {
  obj: { title: string; context: string };
  state?: FormState;
  setformState: Dispatch<SetStateAction<FormState>>;
  setPrevHeight?: Dispatch<SetStateAction<number>>;
  prevHeight?: number;
}

export const FormMessages = ({
  obj,
  state,
  prevHeight,
  setformState,
}: FormMessagesProps) => {
  const { title: errorTitle, context: errorText } = obj;

  const { getIcon } = useGlobalContext();

  const icon =
    state === "error" && getIcon("form_error") ? (
      <CustomSVG
        key={"failed"}
        src={getIcon("form_error")}
        wrapper={"span"}
        width={129}
        height={129}
        className="is-flex"
        alt="form error"
      />
    ) : state === "success" && getIcon("form_success") ? (
      <CustomSVG
        key={"success"}
        src={getIcon("form_success")}
        wrapper={"span"}
        width={129}
        height={129}
        className="is-flex"
        alt="form success"
      />
    ) : null;

  return (
    <div
      key={state}
      className={`${styles["form-state"]} column is-12`}
      style={{
        minHeight: prevHeight,
      }}
    >
      <FadeIn>
        <div className={styles["form-state-content"]}>
          {icon && (
            <div className="columns is-centered">
              <div className="column is-12 is-flex is-justify-content-center is-align-items-center">
                {icon}
              </div>
            </div>
          )}
          <div className="columns is-centered">
            <div className="column is-12 is-flex is-justify-content-center is-align-items-center">
              <span className="h2-small has-text-centered pb-0">
                {errorTitle}
              </span>
            </div>
          </div>
          <div className="columns is-centered">
            <div className="column is-6 is-flex is-justify-content-center is-align-items-center">
              <span
                className="has-text-centered"
                dangerouslySetInnerHTML={{ __html: errorText }}
              />
            </div>
          </div>
          {state === "error" && (
            <div className="columns is-centered">
              <div className="column is-12 is-flex is-justify-content-center is-align-items-center">
                <SimpleButton
                  type="button"
                  text="ZURÜCK ZUM FORMULAR"
                  onClick={() => setformState("init")}
                />
              </div>
            </div>
          )}
        </div>
      </FadeIn>
    </div>
  );
};
